import { render, staticRenderFns } from "./TaxReturnIndex.vue?vue&type=template&id=4d764592"
import script from "./TaxReturnIndex.vue?vue&type=script&lang=js"
export * from "./TaxReturnIndex.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnIndex.vue?vue&type=style&index=0&id=4d764592&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports